import { Phone } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -70 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}

export function SectionHeader({ label, title, align = "left" }) {
    return (
        <Reveal className={align === "center" ? "text-center" : ""}>
            <p className="mb-3 text-[11px] font-bold uppercase tracking-[0.35em] text-swiss-red sm:text-xs">{label}</p>
            <h2 className="text-3xl font-bold leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">{title}</h2>
        </Reveal>
    );
}

export function PhoneCTA({ phoneRaw, phoneDisplay, label, testid, className = "" }) {
    return (
        <a
            href={`tel:${phoneRaw}`}
            data-testid={testid}
            className={`group inline-flex items-center gap-3 px-7 py-4 text-sm font-bold uppercase tracking-widest transition-all duration-300 hover:-translate-y-0.5 sm:px-9 sm:py-5 sm:text-base ${className}`}
        >
            <Phone className="h-5 w-5 transition-transform duration-300 group-hover:rotate-12" />
            <span>{label}</span>
            <span className="hidden font-medium normal-case tracking-normal opacity-75 sm:inline">· {phoneDisplay}</span>
        </a>
    );
}

export function BackHomeButton() {
    return (
        <div className="flex flex-col items-center gap-4 py-14">
            <Link
                to="/"
                data-testid="nav-back-home"
                className="group inline-flex items-center gap-3 border-2 border-ink bg-ink px-8 py-4 text-sm font-bold uppercase tracking-[0.2em] text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-swiss-red hover:border-swiss-red"
            >
                <span className="transition-transform duration-300 group-hover:-translate-x-1">←</span>
                Torna alla Home
            </Link>
            <p className="text-xs text-current opacity-50">Sito dimostrativo realizzato da Vetrina</p>
        </div>
    );
}

export function FloatingBar({ phoneRaw, callLabel }) {
    return (
        <div className="fixed inset-x-4 bottom-4 z-50 flex gap-2 lg:hidden" data-testid="floating-action-bar">
            <a
                href={`tel:${phoneRaw}`}
                data-testid="floating-call-btn"
                className="flex flex-1 items-center justify-center gap-2 bg-swiss-red py-3.5 text-sm font-bold uppercase tracking-widest text-white shadow-[0_4px_20px_rgba(0,0,0,0.25)]"
            >
                <Phone className="h-4 w-4" />
                {callLabel}
            </a>
            <Link
                to="/"
                data-testid="floating-home-btn"
                className="flex items-center justify-center gap-2 bg-ink px-5 py-3.5 text-sm font-bold uppercase tracking-widest text-white"
            >
                Home
            </Link>
        </div>
    );
}

export function MapEmbed({ query, testid }) {
    const src = `https://maps.google.com/maps?q=${encodeURIComponent(query)}&t=&z=16&ie=UTF8&iwloc=&output=embed`;
    return (
        <div className="border border-swiss-line" data-testid={testid}>
            <iframe
                title="Mappa della sede"
                src={src}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="h-72 w-full border-0 sm:h-96"
            />
        </div>
    );
}

export function Stars({ rating }) {
    return (
        <div className="flex gap-0.5" aria-label={`${rating} stelle su 5`}>
            {Array.from({ length: rating }).map((_, i) => (
                <svg key={i} viewBox="0 0 20 20" className="h-4 w-4 fill-current text-swiss-red">
                    <path d="M10 1.5l2.6 5.3 5.9.9-4.2 4.1 1 5.8L10 14.9 4.7 17.6l1-5.8L1.5 7.7l5.9-.9L10 1.5z" />
                </svg>
            ))}
        </div>
    );
}
